// src/reducers/authReducer.js
import secureStorage from "../utils/secureStorage";

// Action types
const LOGIN_SUCCESS = "auth/LOGIN_SUCCESS";
const LOGIN_FAILURE = "auth/LOGIN_FAILURE";
const SET_DEVICE_INFO = "auth/SET_DEVICE_INFO";
const LOGOUT = "auth/LOGOUT";

// Initial state: hydrate from secureStorage
const initialState = {
  token: secureStorage.get("authToken"),
  clinic: secureStorage.get("clinic"),
  user: secureStorage.get("user"),
  deviceInfo: secureStorage.get("deviceInfo"),
  isAuthenticated: !!secureStorage.get("authToken"),
  loading: false,
  error: null,
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
      secureStorage.set("authToken", action.payload.token);
      secureStorage.set("clinic", action.payload.clinic);
      secureStorage.set("user", action.payload.user);
      return {
        ...state,
        token: action.payload.token,
        clinic: action.payload.clinic,
        user: action.payload.user,
        isAuthenticated: true,
        loading: false,
        error: null,
      };

    case LOGIN_FAILURE:
      secureStorage.remove("authToken");
      secureStorage.remove("clinic");
      secureStorage.remove("user");
      return {
        ...state,
        token: null,
        clinic: null,
        user: null,
        isAuthenticated: false,
        loading: false,
        error: action.payload,
      };

    case SET_DEVICE_INFO:
      secureStorage.set("deviceInfo", action.payload);
      return {
        ...state,
        deviceInfo: action.payload,
      };

    case LOGOUT:
      secureStorage.clear();
      return {
        ...initialState,
        token: null,
        clinic: null,
        user: null,
        isAuthenticated: false,
      };

    default:
      return state;
  }
}

// Action-creators
export const loginSuccess = (token, clinic, user) => ({
  type: LOGIN_SUCCESS,
  payload: { token, clinic, user },
});
export const loginFailure = (error) => ({
  type: LOGIN_FAILURE,
  payload: error,
});
export const setDeviceInfo = (info) => ({
  type: SET_DEVICE_INFO,
  payload: info,
});
export const logout = () => ({ type: LOGOUT });
